// Лого StudyHub: раскрытая книга с искрой-вспышкой инсайта.
// Используется в sidebar, mobile-drawer, topbar, site-footer как фирменный знак.
// BrandSparkle остаётся для accent-маркеров AI-возможностей в nav-итемах.
import { useId } from "react";
import { cn } from "@/lib/cn";

export function BrandLogo({ size = 20 }: { size?: number }) {
	const uid = useId();
	const sparkGrad = `brand-logo-spark-${uid}`;
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
			<defs>
				<linearGradient id={sparkGrad} x1="20%" y1="15%" x2="85%" y2="90%">
					<stop offset="0%" stopColor="#FFF6C2" />
					<stop offset="45%" stopColor="#FFD24A" />
					<stop offset="100%" stopColor="#F2A93B" />
				</linearGradient>
			</defs>
			{/* Левая страница */}
			<path d="M3 6 C6 5 9 5 12 6.5 L12 19 C9 17.5 6 17.5 3 18.5 Z" fill="#fff" />
			{/* Правая страница (чуть приглушена для глубины) */}
			<path
				d="M21 6 C18 5 15 5 12 6.5 L12 19 C15 17.5 18 17.5 21 18.5 Z"
				fill="#fff"
				opacity="0.78"
			/>
			{/* Искра-вспышка инсайта над правой страницей */}
			<path
				d="M17 4 L17.8 6 L20 6.8 L17.8 7.6 L17 9.6 L16.2 7.6 L14 6.8 L16.2 6 Z"
				fill={`url(#${sparkGrad})`}
			/>
		</svg>
	);
}

/**
 * Фирменный знак = лого на приподнятой плитке.
 *
 * Сам `BrandLogo` нарисован белым и на светлом фоне исчезает — он всегда живёт
 * на этой плитке. Раскладка «плитка + градиент + ребро» повторена вручную в
 * шапке, футере, шлюзе согласий и утилитарной полосе онбординга; новые места
 * берут её отсюда, чтобы пятая копия не разъехалась с остальными.
 */
export function BrandMark({
	size = 34,
	className,
}: {
	/** Сторона плитки в пикселях. Лого внутри — примерно 60% стороны. */
	size?: number;
	className?: string;
}) {
	return (
		<span
			aria-hidden
			className={cn(
				"inline-flex shrink-0 items-center justify-center rounded-[9px]",
				"[background-image:linear-gradient(155deg,var(--primary-2),var(--primary))]",
				"shadow-[0_2px_0_var(--primary-edge),inset_0_1px_0_rgba(255,255,255,0.3),0_4px_10px_rgba(0,0,0,0.15)]",
				className,
			)}
			style={{ width: size, height: size }}
		>
			<BrandLogo size={Math.round(size * 0.6)} />
		</span>
	);
}
